import React, { useState, useEffect } from 'react';
import BasePage from '../components/BasePage';
import Fields from '../components/Fields';
import Image from '../components/Image';
import DocumentButton from '../components/Buttons/DocumentButton';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { MessageCircleQuestion, BookA, Wrench  } from 'lucide-react';
import FieldsGroup from '../components/FieldsGroup';


const Jerico = (props) => {
  
    // const navigate = useNavigate()

    const fields_groups = [
        {
            key: 'identifiants',
            name: 'Mes identifiants Jerico',
            icon: 'fa-user',
            fields: [
                {
                    key: 'raison_sociale',
                    name: 'Raison sociale'
                },
                {
                    key: 'login',
                    name: 'Identifiant (login)'
                },
                {
                    key: 'decrypted_password',
                    name: 'Mot de passe'
                },
            ]
        },
    ];

    const content = (data) => {
console.log(data);
        // Utilisez la variable data récupérée dans BasePage ici
        // Par exemple, vous pouvez afficher les données ou effectuer toute autre logique avec elles
        if (!data) {
            return false;
        }

         // Extraire le premier élément du tableau identifiantsClient (si le tableau existe)
    const identifiants = data.identifiantsClient ? data.identifiantsClient[0] : {};

    // Créer un objet contenant les données nécessaires pour FieldsGroup
    const dataWithIdentifiants = {
        ...data, // inclure toutes les données existantes
        ...identifiants // inclure les identifiants (login et decrypted_password)
    };

        return (
            <div id="jerico" className="p-6">
               
                {data ? (
                    
                    <>
                        <div>
                            <FieldsGroup fields_groups={fields_groups} data={dataWithIdentifiants} />
                        </div>
                        <div className="mt-8 ">
                            <Link to={`https://${data.url_bo}`} target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                Mon Back office
                                <FontAwesomeIcon icon="fa-solid fa-gears" className="ml-3 text-2xl -rotate-45" />
                            </Link>
                        </div>
                        <div className="mt-8 ">
                            <Link to={`https://${data.url}`} target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                Mon site
                                <FontAwesomeIcon icon="fa-solid fa-arrow-right" className="ml-3 text-2xl -rotate-45" />
                            </Link>
                        </div>
                            
                    </>
                ) : (
                    // Sinon, affiche un message de chargement ou d'erreur
                    <p>Chargement en cours...</p>
                )}
            </div>
        );
    };

    return <BasePage content={content} title={props.title ?? null} />;
};

export default Jerico;
